// removed by extract-text-webpack-plugin
module.exports = {"text":"MeetingInstructions__text___1A3ho"};